module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/recycling-bins/recycle.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/recycling-bins/recycle.png
// module id = 615
// module chunks = 0